
/**
 * Environment configuration helper functions
 * This module centralizes access to environment variables across the application
 */

interface Environment {
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  TRIPLETEX_CONSUMER_TOKEN: string;
  TRIPLETEX_EMPLOYEE_TOKEN: string;
  TRIPLETEX_TOKEN?: string;
  // Add other environment variables as needed
}

// Default fallback values (staging values as fallback)
const defaultEnvironment: Environment = {
  SUPABASE_URL: "https://arbeevmsefggjmxfwrdc.supabase.co", 
  SUPABASE_ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFyYmVldm1zZWZnZ2pteGZ3cmRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0MzMyMjYsImV4cCI6MjA1ODAwOTIyNn0.l2_nz8TZZZz5IGnAQfKstt6Q4tQX2QQkzZMo9RTTh2c",
  TRIPLETEX_CONSUMER_TOKEN: "",
  TRIPLETEX_EMPLOYEE_TOKEN: "",
  TRIPLETEX_TOKEN: ""
};

/**
 * Returns the current environment object containing all required environment variables
 */
export function getEnvironment(): Environment {
  return {
    SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || defaultEnvironment.SUPABASE_URL,
    SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || defaultEnvironment.SUPABASE_ANON_KEY,
    TRIPLETEX_CONSUMER_TOKEN: import.meta.env.VITE_TRIPLETEX_CONSUMER_TOKEN || defaultEnvironment.TRIPLETEX_CONSUMER_TOKEN,
    TRIPLETEX_EMPLOYEE_TOKEN: import.meta.env.VITE_TRIPLETEX_EMPLOYEE_TOKEN || defaultEnvironment.TRIPLETEX_EMPLOYEE_TOKEN,
    TRIPLETEX_TOKEN: import.meta.env.VITE_TRIPLETEX_TOKEN || defaultEnvironment.TRIPLETEX_TOKEN,
  };
}

/**
 * Returns a user-friendly name for the current environment
 */
export function getEnvironmentName(): string {
  // Vite sets the MODE during build/dev
  const mode = import.meta.env.MODE;
  
  if (mode === 'production') {
    return 'production';
  } else if (mode === 'development') {
    return 'development'; 
  } else if (mode === 'staging') {
    return 'staging';
  } else {
    return mode || 'unknown';
  }
}

/**
 * Returns whether the app is running in development mode
 */
export function isDevelopment(): boolean {
  return import.meta.env.DEV === true;
}

/**
 * Returns whether the app is running in production mode
 */
export function isProduction(): boolean {
  return import.meta.env.PROD === true;
}

/**
 * Returns whether the app is running in staging mode
 */
export function isStaging(): boolean {
  return import.meta.env.MODE === 'staging';
}
